import { actions as loadingActions } from "../../../components/loading/index";
import { notification, message } from "antd";

export const removeHOD = email => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    dispatch(loadingActions.showLoading());

    const firestore = getFirestore();
    const uid = getState().firebase.auth.uid;

    firestore
      .doc(`users/${email}`)
      .delete()
      .then(function() {
        message.success("Admin removed successfully");
        loadHodFromDB(dispatch, firestore);
      })
      .catch(function (error) {
        notification.error({
          message: 'Something went Wrong',
          duration: 0,
          description: 'Contact admin@vedic.dev ' + error
        });
        dispatch(loadingActions.hideLoading());
      });
  };
};

export const addHOD = formVal => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    dispatch(loadingActions.showLoading());
    const firestore = getFirestore();
    const displayName = getState().firebase.auth.displayName;
    const uid = getState().firebase.auth.uid;
    firestore
      .doc(`users/${formVal.email}`)
      .set(
        {
          displayName: formVal.name,
          email: formVal.email,
          role: "ADMIN",
          campus: formVal.campus,
          addedBy:{
            displayName:displayName,
            UID:uid
          }
        },
        { merge: true }
      )
      .then(function() {
        message.success("Admin added successfully");
        loadHodFromDB(dispatch, firestore);
      })
      .catch(function (error) {
        notification.error({
          message: 'Something went Wrong',
          duration: 0,
          description: 'Contact admin@vedic.dev ' + error
        });
        dispatch(loadingActions.hideLoading());
      });
  };
};

export const loadHODList = () => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    loadHodFromDB(dispatch, firestore);
  };
};
function loadHodFromDB(dispatch, firestore) {
  dispatch(loadingActions.showLoading());
  firestore
    .collection("users").where('role', '==', 'ADMIN')
    .get()
    .then(doc => {
      dispatch({
        type: "LOAD_HOD_LIST",
        payload: !doc.empty
          ? {
            valid: true,
            data: doc.docs.map((doc, i) => {
              return { key: `${i}`, ...doc.data() };
            }),
            skeltonLoading: false,
          }
          : {
          valid: false,
            skeltonLoading: false
          }
      });
      dispatch(loadingActions.hideLoading());
    })
    .catch(function (error) {
      notification.error({
        message: 'Something went Wrong',
        duration: 0,
        description: 'Contact admin@vedic.dev ' + error,
        onClick: () => {
          
        },
      });
      dispatch(loadingActions.hideLoading());
    });
}
